import {
    Building2,
    ClipboardCheck,
    ReceiptText,
    Ruler,
    FileSearch,
    Wrench,
    FileText,
    Trees,
    Home,
    Landmark,
    DraftingCompass,
    Users,
} from "lucide-react";

export const CONTACT = {
    business: "The Sens Civil Works Consultancy",
    person: "P. Sen Gupta",
    phone1: "9415212751",
    phone2: "9208318881",
    email: "sk.sengupta@rediffmail.com",
    location: "Gorakhpur, Uttar Pradesh, India",
    whatsapp: "https://wa.me/919208318881",
};

export const IMAGES = {
    hero: {
        url: "https://images.unsplash.com/photo-1527335988388-b40ee248d80c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwYXJjaGl0ZWN0fGVufDB8fHx8MTc5MTQ0NjM1MHww&ixlib=rb-4.1.0&q=85",
        alt: "Steel building frame and tower crane at a construction site",
    },
    engineer: {
        url: "https://images.unsplash.com/photo-1742112125567-3e8967bad60f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxjaXZpbCUyMGVuZ2luZWVyJTIwc2l0ZSUyMGNoZWNraW5nfGVufDB8fHx8MTc5MTQ0NjM2M3ww&ixlib=rb-4.1.0&q=85",
        alt: "Construction engineers reviewing plans at a job site",
    },
    inspection: {
        url: "https://images.unsplash.com/photo-1545186070-de624ed19875?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxjaXZpbCUyMGVuZ2luZWVyJTIwc2l0ZSUyMGNoZWNraW5nfGVufDB8fHx8MTc5MTQ0NjM2M3ww&ixlib=rb-4.1.0&q=85",
        alt: "Engineer using a dumpy level for site measurement",
    },
    blueprints: {
        url: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxjaXZpbCUyMGVuZ2luZWVyJTIwYmx1ZXByaW50c3xlbnwwfHx8fDE3OTE0NDYzNTB8MA&ixlib=rb-4.1.0&q=85",
        alt: "Architect drafting building plans with pencil and ruler",
    },
    measuring: {
        url: "https://images.unsplash.com/photo-1667923006173-9e0d2251f608?crop=entropy&cs=srgb&fm=jpg&ixid=M3w7NDQ2NDJ8MHwxfHNlYXJjaHw0fHxtZWFzdXJpbmclMjB0b29scyUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3OTE0NDYzNTB8MA&ixlib=rb-4.1.0&q=85",
        alt: "Worker measuring material on site with precision tools",
    },
    landscaping: {
        url: "https://images.unsplash.com/photo-1761637823730-fab1f300084d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxsYW5kc2NhcGluZyUyMGdhcmRlbiUyMG1vZGVybnxlbnwwfHx8fDE3OTE0NDYzNTB8MA&ixlib=rb-4.1.0&q=85",
        alt: "Modern landscaped garden with stone wall and plants",
    },
    residential: {
        url: "https://images.unsplash.com/photo-1628744448840-55bdb2497bd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxyZXNpZGVudGlhbCUyMGNvbnN0cnVjdGlvbiUyMG1vZGVybnxlbnwwfHx8fDE3OTE0NDYzNTB8MA&ixlib=rb-4.1.0&q=85",
        alt: "Modern residential concrete building under construction",
    },
    maintenance: {
        url: "https://images.unsplash.com/photo-1563166423-482a8c14b2d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxtYWludGVuYW5jZSUyMGNvbnN0cnVjdGlvbiUyMHdvcmtlcnxlbnwwfHx8fDE3OTE0NDYzNjN8MA&ixlib=rb-4.1.0&q=85",
        alt: "Worker carrying out maintenance on a building",
    },
};

export const SERVICES = [
    {
        icon: Building2,
        title: "Construction & Renovation Consultancy",
        short: "Construction & Renovation",
        description:
            "Independent guidance for construction, renovation, material selection, workmanship review, estimates and practical execution decisions.",
        link: "/construction-renovation-consultancy",
    },
    {
        icon: ClipboardCheck,
        title: "Site Inspection & Technical Reporting",
        short: "Site Inspection",
        description:
            "Professional site visits, documented observations, photographs, measurements where appropriate and practical recommendations.",
        link: "/site-inspection",
    },
    {
        icon: ReceiptText,
        title: "Contractor Bill Checking",
        short: "Bill Checking",
        description:
            "Independent review of contractor bills, quantities, measurements, BOQs, rates, extra items and supporting records.",
        link: "/boq-bill-review",
    },
    {
        icon: Ruler,
        title: "BOQ & Quantity Verification",
        short: "BOQ Verification",
        description:
            "Review of quantities, specifications, inclusions, exclusions and practical requirements.",
        link: "/boq-bill-review",
    },
    {
        icon: FileSearch,
        title: "Estimate & Quotation Review",
        short: "Estimate Review",
        description:
            "Independent comparison and review of contractor quotations, estimates and proposed work scopes.",
        link: "/contact?service=Estimate%2FQuotation%20Review",
    },
    {
        icon: Wrench,
        title: "Maintenance Assessment & Planning",
        short: "Maintenance Planning",
        description:
            "Assessment of maintenance requirements and preparation of practical maintenance recommendations.",
        link: "/maintenance-consultancy",
    },
    {
        icon: FileText,
        title: "Tender & BOQ Documentation",
        short: "Tender Documentation",
        description:
            "Preparation and review of BOQs, specifications, comparative statements and tender-related documentation.",
        link: "/contact?service=Tender%20%26%20BOQ%20Documentation",
    },
    {
        icon: Trees,
        title: "Landscape & Garden Consultancy",
        short: "Landscaping",
        description:
            "Practical guidance for garden planning, plant selection, hardscape, irrigation and maintenance.",
        link: "/landscaping-consultancy",
    },
];

export const AUDIENCES = [
    {
        icon: Home,
        title: "Homeowners",
        description:
            "For new construction, renovation, contractor quotations, bills and site decisions — so every major decision is taken with independent technical backing.",
    },
    {
        icon: Landmark,
        title: "Property Owners",
        description:
            "For maintenance, repair and periodic property assessment that protects the value and safety of your asset.",
    },
    {
        icon: DraftingCompass,
        title: "Architects & Small Developers",
        description:
            "For quantity review, documentation, site support and technical coordination throughout the project.",
    },
    {
        icon: Users,
        title: "Housing Societies & Institutions",
        description:
            "For maintenance planning, contractor bill verification and technical reporting that stands up to committee scrutiny.",
    },
];

export const STEPS = [
    {
        number: "01",
        title: "Tell Us What You Need",
        description:
            "Call, WhatsApp or send the enquiry form. Describe your project, stage and the decision you are facing.",
    },
    {
        number: "02",
        title: "Share Documents / Project Details",
        description:
            "Share drawings, BOQs, quotations, contractor bills or photographs — whatever is relevant to the review.",
    },
    {
        number: "03",
        title: "Consultation or Site Inspection",
        description:
            "A technical discussion, a site visit, or both — depending on the scope agreed for your engagement.",
    },
    {
        number: "04",
        title: "Receive Recommendations / Report",
        description:
            "Clear, documented observations and practical recommendations you can act on with confidence.",
    },
];

export const FAQS = [
    {
        question: "Which areas do you serve?",
        answer:
            "The consultancy is based in Gorakhpur, Uttar Pradesh. Site inspections are carried out across Gorakhpur and nearby districts, while document-based reviews such as BOQ, bill and estimate checking can be handled remotely for projects anywhere in India.",
    },
    {
        question: "Are you a contractor?",
        answer:
            "No. The Sens Civil Works Consultancy is an independent consultancy and does not execute construction work. Advice and reviews are therefore unbiased and focused only on the client's interest.",
    },
    {
        question: "What does a site inspection include?",
        answer:
            "A site visit with photographic documentation, checklist-based observations, basic measurements where appropriate, and practical recommendations compiled into a written report.",
    },
    {
        question: "Is the inspection a structural safety certificate?",
        answer:
            "No. The inspection is based on the agreed scope and visible, site-accessible conditions, and does not constitute a structural safety certification unless specifically stated in the engagement.",
    },
    {
        question: "Can you check a contractor bill before I pay?",
        answer:
            "Yes. Contractor bills, quantities, measurements, BOQs, rates, extra items and supporting records can be independently reviewed, with documented observations shared before you make payment decisions.",
    },
    {
        question: "How are consultancy fees decided?",
        answer:
            "Fees depend on the scope of the engagement — for example a single site inspection, a bill review, or ongoing project support. A clear fee is quoted and agreed after understanding your requirements, before any work begins.",
    },
    {
        question: "How do I get started?",
        answer:
            "Call, WhatsApp or submit the contact form with a short description of your requirement. You will be guided on what documents or details to share for the first review.",
    },
];

export const SERVICE_OPTIONS = [
    "Site Inspection",
    "Construction Consultancy",
    "Renovation Consultancy",
    "BOQ Review",
    "Bill Checking",
    "Estimate/Quotation Review",
    "Maintenance Consultancy",
    "Landscaping",
    "Other",
];

export const PROJECT_TYPES = [
    "New Construction",
    "Renovation",
    "Maintenance / Repair",
    "Commercial Project",
    "Residential Project",
    "Society / Institutional",
    "Landscape / Garden",
    "Other",
];
